// 가방 창 「아바타」 탭 DOM(레인 E, 그래픽 위주). 값은 avatarPanelModel.ts(순수)가 만들고 여기서는 그리기만 한다.
// 위: 부위 5칸(등급색 테두리, 빈 칸은 점선 실루엣) · 외형 숨기기 토글 · 보유 카드 격자 · 아래: 합계·세트 진행 띠.
// RpgUi가 값이 바뀔 때만 다시 그린다(프레임 루프에서 부르지 않는다).
import type { GameCommand, GameView } from '../shared/types';
import { FONT, FONT_NUM, el } from './dom';
import { assetUrl } from '../pwa/assetMap';
import { avatarPanelModel, type AvatarCardView, type CraftItemView } from './avatarPanelModel';
import { makeRequestId } from './rpgModel';

/** 탭 아이콘: 옷걸이에 걸린 망토 */
export const AVATAR_TAB_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a3 3 0 0 0-3 3h2a1 1 0 1 1 1 1 1 1 0 0 0-1 1v1.2L2.4 15.4A1.5 1.5 0 0 0 3.4 18H8v4h8v-4h4.6a1.5 1.5 0 0 0 1-2.6L13 8.2V7.8A3 3 0 0 0 15 5a3 3 0 0 0-3-3z"/></svg>';

const STYLE_ID = 'dh-avatar-style';
const GOLD = '#f2c14e', GREEN = '#3fd07a';
const CSS =
  '.dh-av{display:flex;flex-direction:column;gap:10px;font-family:' + FONT + ';color:#eef2ff;min-width:0}' +
  '.dh-av-slots{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:6px}' +
  '.dh-av-slot{position:relative;aspect-ratio:1;min-width:0;padding:0;border-radius:10px;border:2px solid var(--gc,#4a5578);' +
  'background:radial-gradient(circle at 50% 38%,#20304f 0%,#121a33 62%,#0b1022 100%);box-shadow:inset 0 0 10px rgba(0,0,0,.55);overflow:hidden;cursor:pointer;color:#cfd8f5}' +
  '.dh-av-slot img{position:absolute;inset:8%;width:84%;height:84%;object-fit:contain;filter:drop-shadow(0 2px 3px rgba(0,0,0,.6));pointer-events:none}' +
  '.dh-av-slot.empty{cursor:default;border-style:dashed;border-color:rgba(174,185,218,.35);background:rgba(10,14,28,.8)}' +
  '.dh-av-slot .nm{position:absolute;left:0;right:0;bottom:1px;text-align:center;font:800 10px ' + FONT + ';color:#cfd8f5;text-shadow:0 1px 2px #000,0 0 3px #000;pointer-events:none}' +
  '.dh-av-slot.empty .nm{position:absolute;inset:0;display:grid;place-items:center;color:#7d86a8;bottom:auto}' +
  '.dh-av-slot:disabled{opacity:.6;cursor:default}' +
  '.dh-av-hide{align-self:flex-start;min-height:var(--dh-hit-min,34px);padding:4px 14px;border-radius:17px;border:1.5px solid rgba(174,185,218,.5);background:rgba(14,20,40,.9);color:#cfd8f5;font:800 13px ' + FONT + ';cursor:pointer}' +
  '.dh-av-hide[aria-pressed="true"]{border-color:' + GOLD + ';background:rgba(242,193,78,.18);color:#ffe7a0}' +
  '.dh-av-hide:disabled{opacity:.6;cursor:default}' +
  '.dh-av-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:8px}' +
  '.dh-av-card{position:relative;display:flex;flex-direction:column;gap:4px;min-width:0;padding:8px;text-align:left;border-radius:12px;border:2px solid var(--gc,#4a5578);' +
  'background:linear-gradient(180deg,rgba(26,35,66,.95),rgba(11,15,32,.95));color:#eef2ff;cursor:pointer;font-family:' + FONT + '}' +
  '.dh-av-card.eq{cursor:default;box-shadow:0 0 0 1px ' + GOLD + ',0 0 10px rgba(242,193,78,.4)}' +
  '.dh-av-card:disabled:not(.eq){opacity:.6;cursor:default}' +
  '.dh-av-card .top{display:flex;align-items:center;gap:6px}' +
  '.dh-av-card .ic{position:relative;flex:0 0 auto;width:46px;height:46px;border-radius:9px;border:2px solid var(--gc);background:radial-gradient(circle at 50% 40%,#20304f,#0d1424 72%)}' +
  '.dh-av-card .ic img{position:absolute;inset:6%;width:88%;height:88%;object-fit:contain}' +
  '.dh-av-card .sw{flex:0 0 auto;width:14px;height:14px;border-radius:50%;border:1.5px solid #fff;box-shadow:0 0 0 1px #000,0 0 6px var(--tint)}' +
  '.dh-av-card b{display:block;min-width:0;font:900 13px ' + FONT + ';color:var(--gc);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
  '.dh-av-card .st{font:700 11.5px ' + FONT + ';color:#cfd8f5}' +
  '.dh-av-card .tags{display:flex;gap:4px;flex-wrap:wrap}' +
  '.dh-av-card .tags span{padding:0 6px;border-radius:9px;font:800 10px ' + FONT + ';white-space:nowrap;color:#cfe0ff;background:rgba(74,140,255,.18);border:1px solid rgba(74,140,255,.45)}' +
  '.dh-av-card .tags span.trade{color:#ffd9b0;background:rgba(255,120,60,.16);border-color:rgba(255,140,70,.5)}' +
  '.dh-av-card .ck{position:absolute;right:4px;top:4px;width:18px;height:18px;border-radius:50%;background:' + GOLD + ';color:#1a1206;display:grid;place-items:center;font:900 12px ' + FONT + ';box-shadow:0 1px 2px #000}' +
  '.dh-av-band{display:flex;flex-direction:column;gap:5px;padding:8px 10px;border-radius:12px;border:1.5px solid rgba(242,193,78,.4);background:linear-gradient(180deg,rgba(28,38,72,.92),rgba(12,17,36,.92))}' +
  '.dh-av-band div{display:flex;align-items:center;gap:6px;min-width:0;font:700 12.5px ' + FONT + ';color:#eef2ff}' +
  '.dh-av-band .cap{padding:0 6px;border-radius:9px;font:900 10px ' + FONT + ';color:#1a1206;background:' + GOLD + '}' +
  '.dh-av-band .set{flex-wrap:wrap;color:#7d86a8}.dh-av-band .set.on{color:#7dffa0}' +
  '.dh-av-band .set em{font:900 12px ' + FONT_NUM + ';font-style:normal;color:#ffe7a0}' +
  '.dh-av-band .set span.on{color:#7dffa0;font-weight:900}' +
  '.dh-av-craft{display:flex;flex-direction:column;gap:8px;padding:8px 10px;border-radius:12px;border:1.5px solid rgba(106,200,255,.45);background:linear-gradient(180deg,rgba(24,36,70,.92),rgba(11,16,34,.92))}' +
  '.dh-av-craft h4{margin:0;font:900 14px ' + FONT + ';color:#bfe6ff}' +
  '.dh-av-craft .res{padding:6px 10px;border-radius:9px;font:800 13px ' + FONT + ';color:#ffd9b0;background:rgba(255,120,60,.16);border:1px solid rgba(255,140,70,.5)}' +
  '.dh-av-craft .res.ok{color:#bfffd0;background:rgba(63,208,122,.16);border-color:rgba(63,208,122,.55)}' +
  '.dh-av-craft .reg{display:flex;flex-direction:column;gap:6px}' +
  '.dh-av-craft .reg>b{font:900 13px ' + FONT + ';color:#eef2ff}.dh-av-craft .reg>b em{font:900 13px ' + FONT_NUM + ';font-style:normal;color:#ffe7a0}' +
  '.dh-av-craft .lst{display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:6px}' +
  '.dh-av-craft .it{display:flex;align-items:center;gap:8px;min-width:0;min-height:var(--dh-hit-min,44px);padding:4px 6px 4px 8px;border-radius:10px;border:1.5px solid var(--gc,#4a5578);background:rgba(10,14,28,.85)}' +
  '.dh-av-craft .it .tx{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:1px}' +
  '.dh-av-craft .it .tx b{font:900 12.5px ' + FONT + ';color:var(--gc);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
  '.dh-av-craft .it .tx span{font:700 11.5px ' + FONT + ';color:#cfd8f5}' +
  '.dh-av-craft .it button{flex:0 0 auto;min-width:max(76px,var(--dh-hit-min,44px));min-height:var(--dh-hit-min,44px);padding:4px 10px;border-radius:10px;border:2px solid #e2b24a;background:linear-gradient(180deg,#f7d57a,#c98c22);color:#2a1a04;font:900 13px ' + FONT + ';cursor:pointer}' +
  '.dh-av-craft .it button:disabled{border-color:rgba(174,185,218,.4);background:rgba(40,48,76,.9);color:#9aa6c8;cursor:default}' +
  '.dh-av-craft .none{font:700 12.5px ' + FONT + ';color:#9aa6c8}' +
  '.dh-av-msg{padding:16px;text-align:center;font:700 13px ' + FONT + ';color:#9aa6c8}';

function ensureStyle(): void {
  if (typeof document === 'undefined' || document.getElementById(STYLE_ID)) return;
  const st = document.createElement('style');
  st.id = STYLE_ID;
  st.textContent = CSS;
  document.head.appendChild(st);
}

function img(parent: HTMLElement, icon: string): void {
  const im = el('img', '', parent) as HTMLImageElement;
  im.alt = ''; im.draggable = false; im.decoding = 'async';
  im.addEventListener('error', () => { im.style.visibility = 'hidden'; });
  im.src = assetUrl(icon);
}

export function renderAvatarPanel(body: HTMLElement, v: GameView, send: (c: GameCommand) => void, locked: boolean): void {
  ensureStyle();
  const root = el('div', '', body);
  root.className = 'dh-av';
  root.dataset.testid = 'avatar-panel';
  const a = v.avatar;
  if (!a) { el('div', '', root, '아바타 정보를 불러오는 중이다').className = 'dh-av-msg'; return; }
  const m = avatarPanelModel(a, v.profile.gold);

  const slots = el('div', '', root);
  slots.className = 'dh-av-slots';
  for (const s of m.slots) {
    const c = s.card;
    const b = el('button', '', slots) as HTMLButtonElement;
    b.type = 'button';
    b.dataset.testid = 'avatar-slot-' + s.slot;
    b.className = 'dh-av-slot' + (c ? '' : ' empty');
    if (c) {
      b.style.setProperty('--gc', c.gradeColor);
      img(b, c.icon);
      el('span', '', b, s.label).className = 'nm';
      b.setAttribute('aria-label', s.label + ': ' + c.name + ' (누르면 해제)');
      b.disabled = locked;
      b.addEventListener('click', () => send({ type: 'avatarUnequip', slot: s.slot }));
    } else {
      el('span', '', b, s.label).className = 'nm';
      b.setAttribute('aria-label', s.label + ': 비어 있음');
      b.disabled = true;
    }
  }

  const hide = el('button', '', root, '외형 숨기기') as HTMLButtonElement;
  hide.type = 'button';
  hide.className = 'dh-av-hide';
  hide.dataset.testid = 'avatar-hide';
  hide.setAttribute('aria-pressed', a.hide ? 'true' : 'false');
  hide.disabled = locked;
  hide.addEventListener('click', () => send({ type: 'avatarHide', hide: !a.hide }));

  const grid = el('div', '', root);
  grid.className = 'dh-av-grid';
  for (const c of m.owned) card(grid, c, send, locked);

  craftArea(root, m, send, locked);

  const band = el('div', '', root);
  band.className = 'dh-av-band';
  band.dataset.testid = 'avatar-totals';
  if (m.totals.length === 0) el('div', '', band, '장착 효과 없음');
  for (const t of m.totals) {
    const ln = el('div', '', band);
    el('span', '', ln, t.text);
    if (t.capped) el('span', '', ln, '상한').className = 'cap';
  }
  for (const s of m.sets) {
    const ln = el('div', '', band);
    ln.className = 'set' + (s.on2 ? ' on' : '');
    ln.dataset.set = s.id;
    el('span', '', ln, s.name);
    el('em', '', ln, s.count + '/3');
    el('span', '', ln, '2: ' + s.fx2).className = s.on2 ? 'on' : '';
    el('span', '', ln, '3: ' + s.fx3).className = s.on3 ? 'on' : '';
  }
}

function card(parent: HTMLElement, c: AvatarCardView, send: (cmd: GameCommand) => void, locked: boolean): void {
  const b = el('button', '', parent) as HTMLButtonElement;
  b.type = 'button';
  b.className = 'dh-av-card' + (c.equipped ? ' eq' : '');
  b.dataset.testid = 'avatar-card-' + c.id;
  b.style.setProperty('--gc', c.gradeColor);
  b.style.setProperty('--tint', c.tint);
  b.setAttribute('aria-label', c.name + ' ' + c.gradeName + (c.equipped ? ' · 장착 중' : ''));
  const top = el('div', '', b);
  top.className = 'top';
  const ic = el('div', '', top);
  ic.className = 'ic';
  img(ic, c.icon);
  const sw = el('i', '', top);
  sw.className = 'sw';
  sw.style.background = c.tint;
  el('b', '', b, c.name);
  for (const l of c.statLines) el('div', '', b, l).className = 'st';
  const tags = el('div', '', b);
  tags.className = 'tags';
  el('span', '', tags, c.gradeName);
  if (c.setName) el('span', '', tags, c.setName);
  if (c.tradable) el('span', '', tags, '거래 가능').className = 'trade';
  if (c.equipped) el('span', '', b, '✓').className = 'ck';
  else {
    b.disabled = locked;
    b.addEventListener('click', () => send({ type: 'avatarEquip', id: c.id }));
  }
}

/** 「제작」 영역: 조각이 있는 지역마다 만들 수 있는 항목(비용·부족 이유)과 결과 띠. 조각은 같은 지역 아바타가 겹칠 때 쌓인다 */
function craftArea(root: HTMLElement, m: ReturnType<typeof avatarPanelModel>, send: (cmd: GameCommand) => void, locked: boolean): void {
  const box = el('div', '', root);
  box.className = 'dh-av-craft';
  box.dataset.testid = 'avatar-craft';
  el('h4', '', box, '제작 — 겹친 아바타는 조각이 돼요');
  if (m.craftResult) {
    const r = el('div', '', box, m.craftResult.text);
    r.className = 'res' + (m.craftResult.ok ? ' ok' : '');
    r.dataset.testid = 'avatar-craft-result';
    r.setAttribute('role', 'status');
  }
  if (m.craft.length === 0) { el('div', '', box, '아직 조각이 없어요. 이미 가진 아바타가 또 나오면 그 지역 조각 1개로 바뀌어요.').className = 'none'; return; }
  for (const reg of m.craft) {
    const g = el('div', '', box);
    g.className = 'reg';
    g.dataset.testid = 'avatar-craft-region-' + reg.region;
    const h = el('b', '', g, '지역 ' + reg.region + ' 조각 ');
    el('em', '', h, String(reg.shards));
    const lst = el('div', '', g);
    lst.className = 'lst';
    for (const it of reg.items) craftItem(lst, it, send, locked);
  }
}

function craftItem(parent: HTMLElement, it: CraftItemView, send: (cmd: GameCommand) => void, locked: boolean): void {
  const row = el('div', '', parent);
  row.className = 'it';
  row.style.setProperty('--gc', it.gradeColor);
  const tx = el('div', '', row);
  tx.className = 'tx';
  el('b', '', tx, it.name);
  el('span', '', tx, it.gradeName + ' · ' + it.slotLabel + ' · ' + it.costText);
  const b = el('button', '', row, it.label) as HTMLButtonElement;
  b.type = 'button';
  b.dataset.testid = 'avatar-craft-' + it.id;
  b.disabled = locked || !it.can;
  b.setAttribute('aria-label', it.name + ' 제작: ' + it.costText + (it.can ? '' : ' (' + it.label + ')'));
  b.addEventListener('click', () => send({ type: 'avatarCraft', id: it.id, requestId: makeRequestId() }));
}
